import { render, staticRenderFns } from "./ItemDescriptions.vue?vue&type=template&id=7d593b9a"
import script from "./ItemDescriptions.vue?vue&type=script&lang=js"
export * from "./ItemDescriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmImg: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmImg.vue').default,TlmContentfulMarkdown: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmContentfulMarkdown.vue').default})
